import Crumb from "features/breadcrumbs/Crumb";
import { ShowUserParams } from "./UserPage";
import { Person } from "@mui/icons-material";
import { useGetUserByIdQuery } from "app/api/users";
import useAssertParams from "hooks/useAssertParams";

const UserCrumb: React.FC = () => {
  const { userId } = useAssertParams<ShowUserParams>();
  const { data: user } = useGetUserByIdQuery({ userId });

  return (
    <Crumb to={`/users/view/${userId}`} icon={<Person />}>
      {user?.userName}
    </Crumb>
  );
};

export default UserCrumb;
